import { createClient } from "next-sanity";
import { getStudioBaseUrl, getStudioUrl } from "./studioUrl";

export const studioUrl = getStudioUrl(
	getStudioBaseUrl({
		dataset: process.env.NEXT_PUBLIC_SANITY_DATASET,
		nodeEnv: process.env.NODE_ENV,
		studioUrl: process.env.NEXT_PUBLIC_SANITY_STUDIO_URL,
		developmentStudioUrl: process.env.NEXT_PUBLIC_SANITY_STUDIO_DEV_URL,
		productionStudioUrl: process.env.NEXT_PUBLIC_SANITY_STUDIO_PROD_URL,
	}),
	process.env.NEXT_PUBLIC_SANITY_DATASET,
);

export const client = createClient({
	token: process.env.SANITY_READ_TOKEN,
	projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID,
	dataset: process.env.NEXT_PUBLIC_SANITY_DATASET,
	useCdn: process.env.VERCEL_ENV === "production" ? false : true, // using ISR on production only
	apiVersion: process.env.NEXT_PUBLIC_SANITY_API_VERSION ?? "2023-03-25",
	perspective: "published",
	stega: {
		studioUrl,
		filter: props => {
			const field = props.sourcePath.at(-1);
			const parent = props.sourcePath.at(-2);

			// Button labels are rendered through <Button>/<ButtonLink>, which strip the
			// source map out of the text and re-attach it as a data-sanity attribute.
			// Encoding them is what makes the buttons editable in the Presentation tool.
			if (
				field === "buttonLabel" ||
				field === "submitButtonText" ||
				(field === "label" && (parent === "callToAction" || parent === "contactCta"))
			) {
				return props.filterDefault(props);
			}

			// Everything below is read as a value rather than rendered as prose — an
			// enum compared in code, an attribute, or a form field key — so the
			// invisible stega characters would corrupt it.
			if (
				typeof field === "string" &&
				[
					"align",
					"alignment",
					"altText",
					"brandIcon",
					"category",
					"solsticeCategory",
					"solsticeVictoriaCategory",
					"flourish",
					"label",
					"site",
				].includes(field)
			) {
				return false;
			}

			return props.filterDefault(props);
		},
	},
});
